import React, { useState } from "react";
import { Document, Page, Text, View, StyleSheet } from "@react-pdf/renderer";

// 🎨 Styling PDF
const styles = StyleSheet.create({
  page: {
    padding: 30,
    fontSize: 10,
    fontFamily: "Helvetica",
  },
  section: {
    marginBottom: 1,
    border: "1 solid white",
  },
  title: {
    fontSize: 12,
    textAlign: "center",
    marginBottom: 5,
    fontWeight: "bold",
    // border: '1 solid wite',
  },
  text: {
    marginBottom: 2,
    paddingBottom: 2,
  },
  tableHeader: {
    flexDirection: "row",
    borderBottom: "1 solid black",
    backgroundColor: "#eee",
    paddingVertical: 2,
    marginTop: 2,
    border: "1 solid black",
    fontSize: 8,
  },
  tableRow: {
    flexDirection: "row",
    borderBottom: "0.5 solid #ccc",
    paddingVertical: 2,
  },
  colKode: { flex: 0.4 },
  colNama: { flex: 2 },
  colDebit: { flex: 0.6, textAlign: "right" },
  colKredit: { flex: 0.6, textAlign: "right" },
  totalRow: {
    flexDirection: "row",
    marginTop: 5,
    borderTop: "1 solid black",
    paddingTop: 4,
    fontWeight: "bold",
  },
});

// 🧾 Komponen PDF
const MyReportvoucher = ({ header, details, userBy }) => {
  const totalDebit = details.reduce((sum, d) => sum + d.debit, 0);
  const totalCredit = details.reduce((sum, d) => sum + d.credit, 0);
  // const [date,setDate] = useState(new Date().toLocaleString())

  const Datetime = new Date().toLocaleString("id-ID", {
    day: "2-digit",
    month: "2-digit",
    year: "numeric",
    hour: "2-digit",
    minute: "2-digit",
    second: "2-digit",
  });

  const formattedDate = new Date(header.date_voucher).toLocaleString("id-ID", {
    day: "2-digit",
    month: "2-digit",
    year: "numeric",
    hour: "2-digit",
    minute: "2-digit",
    second: "2-digit",
  });

  // console.log(details)

  return (
    <Document>
      <Page size="A4" style={styles.page}>
        {/* 🧷 Judul */}
        <View style={{ fontSize: "13px" }}>
          <Text style={styles.title}>Green Hill Resort Kemuning Group</Text>
          <Text style={styles.title}>Jurnal Umum</Text>
        </View>
        {/* 📌 Header info */}
        <View style={styles.section}>
          <Text style={styles.text}>Doc No: {header.doc_no}</Text>
          {/* <Text style={styles.text}>Date Voucher: {header.date_voucher}</Text>  */}
          <Text style={styles.text}>Date Voucher: {formattedDate}</Text>
          <Text style={styles.text}>Amount: {header.amount_voucher.toLocaleString()}</Text>
          <Text style={styles.text}>Keterangan: {header.ket}</Text>
          {/* <Text style={styles.text}>Diajukan oleh: {header.dibuat_oleh}</Text>           */}
        </View>
        <View style={{ marginTop: "1px" }}>
          <Text>
            Tanggal : {Datetime} &nbsp;&nbsp;&nbsp;&nbsp;user by : {userBy}
          </Text>
        </View>
        {/* 📊 Tabel detail */}
        <View style={styles.tableHeader}>
          <Text style={styles.colKode}>Chart Code</Text>
          <Text style={styles.colNama}>Chart Desc</Text>
          <Text style={styles.colDebit}>Debit</Text>
          <Text style={styles.colKredit}>Credit</Text>
        </View>

        {details.map((item, idx) => (
          <View style={styles.tableRow} key={idx}>
            <Text style={styles.colKode}>{item.chart_account_code}</Text>
            <Text style={styles.colNama}>{item.chart_account_desc}</Text>
            <Text style={styles.colDebit}>{item.debit.toLocaleString()}</Text>
            <Text style={styles.colKredit}>{item.credit.toLocaleString()}</Text>
          </View>
        ))}

        {/* 🧮 Total */}
        <View style={styles.totalRow}>
          <Text style={styles.colKode}></Text>
          <Text style={styles.colNama}>TOTAL</Text>
          <Text style={styles.colDebit}>{totalDebit.toLocaleString()}</Text>
          <Text style={styles.colKredit}>{totalCredit.toLocaleString()}</Text>
        </View>

        {/* Diajukan Oleh pindah ke bawah kiri */}
        <View
          style={{
            marginTop: 10,
            flexDirection: "row",
            justifyContent: "space-between",
          }}
        >
          <View style={{ flexDirection: "column", alignItems: "center" }}>
            <Text style={styles.text}>Diajukan oleh:</Text>
            <Text>{"\n"}</Text>
            <Text>{"\n"}</Text>
            <Text>{"\n"}</Text>
            <Text>{"\n"}</Text>
            <Text style={styles.text}>({header.dibuat_oleh})</Text>
          </View>

          <View style={{ flexDirection: "column", alignItems: "center" }}>
            <Text style={styles.text}>Disetujui oleh:</Text>
            <Text>{"\n"}</Text>
            <Text>{"\n"}</Text>
            <Text>{"\n"}</Text>
            <Text>{"\n"}</Text>
            <Text style={styles.text}>({header.disetujui_oleh})</Text>
          </View>
        </View>
      </Page>
    </Document>
  );
};

export default MyReportvoucher;
